import React from "react";
import ReactDOM from "react-dom/client";
import "./styles/global.css";
import "./styles/app.css";
import WrappedApp from "./App.jsx";

ReactDOM.createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <WrappedApp />
  </React.StrictMode>
);
